export default __webpack_public_path__ + "static/media/certificate_C.ae6fe93d.WebP";